import React from 'react';
import {Space, Tag} from "antd";
import Table from "../../../../componets/Table";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { ColumnsType } from "antd/es/table";
import { SessionInterface } from "../../../../store/mine_craft/sessionsSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../../componets/Buttons";
import { StopOutlined } from "@ant-design/icons";
import { setBanId } from "../../../../store/mine_craft/devicesSlice";
import Block from "../../Devices/Block";
import Title from '../../Devices/_partials/_Title';
import Meta from "../../Users/_partials/_Meta";
import OptionalLink from "../../../../componets/OptionalLink";

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const ids = useAppSelector(state => state.mineCraft.sessions.ids);
  const sessions = useAppSelector(state => state.mineCraft.sessions.entities);
  const devices = useAppSelector(state => state.mineCraft.devices.entities);
  const users = useAppSelector(state => state.mineCraft.users.entities);
  const data = ids ? ids.map(id => sessions[id]) : [];
  const dispatch = useAppDispatch();

  function onClickBan(id: number) {
    const device = devices[id];

    if (device) {
      dispatch(setBanId([device.id]));
    }
  }

  const Icon = ({ icon }: { icon: any }) => <FontAwesomeIcon icon={icon} className='v-mr-5' />;

  const renderDeviceType = (device_id: number) => {
    const device = devices[device_id];

    if (!device) {
      return null;
    }

    if(device.device_type === 'iPad') {
      return <Icon icon={"fa-solid fa-tablet"} />
    } else {
      return <Icon icon={"fa-solid fa-mobile"} />
    }
  }

  const renderDeviceVendor = (device_id: number) => {
    const device = devices[device_id];

    if (!device) {
      return null;
    }

    return <OptionalLink link={device.url}>{device.vendor}</OptionalLink>;
  }

  const renderDevice = (device_id: number) => (
    <>
      {renderDeviceType(device_id)}
      <small>{<Title name={device_id} bannedUntil={devices[device_id]?.banned_until} />}</small>
    </>
  )

  const renderUser = (user_id: number | null) => {
    const user = user_id ? users[user_id] : undefined;

    if (!user) {
      return <span>-</span>;
    }

    return <Meta user={user} size='xsmall' className='v-session-list--meta-user' />
  }

  const columns: ColumnsType<SessionInterface> = [
    {
      key: 'id',
      title: 'Id',
      render: (_, { id }) => id,
      width: 30
    },

    {
      key: 'uid',
      title: 'UID',
      render: (_, { uid }) => <Tag color="processing">{uid.toUpperCase()}</Tag>,
      width: 30
    },

    {
      key: 'device_type',
      title: 'device',
      render: (_, { device_id }) => renderDevice(device_id),
      width: 30
    },

    {
      key: 'user_id',
      title: 'user',
      render: (_, { user_id }) => renderUser(user_id),
      width: 30
    },

    {
      key: 'vendor',
      title: 'Vendor ID',
      render: (_, { device_id }) => renderDeviceVendor(device_id),
      width: 250
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => <small>{formattedDate(created_at).dateTime}</small>,
      width: 120
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => <small>{formattedDate(updated_at).dateTime}</small>,
      width: 120
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { device_id}) => (
        <Space size="middle">
          <Button key='button-ban' onClick={() => onClickBan(device_id)} title='Block' icon={StopOutlined} />
        </Space>
      ),
      width: 50
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Block />
    </div>
  )
}

export default _ListTable;
